export const ORDER_DESIGN_REVIEW_TIMEFRAME_DAYS = 2;
